// Create Floating Cookie Button
function createFloatingCookieButton() {
  const button = document.createElement('button');
  button.className = 'floating-cookie-button';
  button.tabIndex = 0;
  button.type = 'button';
  button.id = 'xxx-ot-sdk-btn';
  button.onclick = function () {
    if (window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
      window.OneTrust.ToggleInfoDisplay();
    }
  };

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', '33px');
  svg.setAttribute('height', '33px');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svg.setAttribute('stroke', '#ffffff');

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute(
    'd',
    'M9 16H9.01M12 11H12.01M7 10H7.01M15 16H15.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C12 5.76142 13.7909 8 16 8C16 10.2091 18.2386 12 21 12Z'
  );
  path.setAttribute('stroke', '#ffffff');
  path.setAttribute('stroke-width', '2');
  path.setAttribute('stroke-linecap', 'round');
  path.setAttribute('stroke-linejoin', 'round');

  svg.appendChild(path);
  button.appendChild(svg);

  return button;
}

// Create Privacy Notice Link
function createPrivacyLink() {
  const privacyLink = document.createElement('a');
  privacyLink.target = '_blank';
  privacyLink.className = 'text-sm font-ApercuPro-Regular';
  privacyLink.href = 'https://www.asurion.com/en-gb/privacy-notice/';
  privacyLink.rel = 'noreferrer';
  privacyLink.textContent = 'Privacy Notice';

  return privacyLink;
}



// Export individual components
export {
  createFloatingCookieButton,
  createPrivacyLink,  
};